































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-misc.scss';
import AButton from '@/components/common/AButton.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { EyeIcon, EyeOffIcon, InfoIcon } from 'vue-feather-icons';

@Component({ name: 'not-found', components: { AButton, EyeIcon, EyeOffIcon, InfoIcon } })
class NotFound extends mixins(BaseMixin) {}

export default NotFound;
